import React, { useRef, useState } from 'react';
import { DataGrid, Box, DateBox, Button } from 'devextreme-react';
import { Item } from "devextreme-react/box";
import {
    Paging,
    Pager,
    Column,
    Export,

    SearchPanel,
    Grouping,
    Summary,
    TotalItem,
} from 'devextreme-react/data-grid';

import { _path } from "../../../data/headerNavigation";
import { formatDateMMyy, resources } from '../../../data/app';
import { cellRender, cellRenderBold, formatToMoney, formatToMoneyNumber, onCellPreparedSales, } from '../../../utils/common';


import http from '../../../utils/http';
import { dateByReport } from '../../../data/defaultObjects';
import { userService } from '../../../services/user.service';
import useAuthorization from '../../../hooks/useAuthorization';

import './resumen.css';

const ResumenVentasVendedor = (props) => {

    const user = userService.getUser();

    const [areaId,] = useState(user.areaId);

    const [dateFrom, setDateFrom] = useState(dateByReport.from);
    const [data, setData] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [_,] = useAuthorization(resources.verReporteDeVentas);
    //const [ options, setOptions ] = useState([]);

    let refData = useRef(null);

    const changeDateFrom = e => setDateFrom(e.value);

    function getLastDayOfMonth(date) {
        // Clonar la fecha original para evitar mutarla
        const original = new Date(date);

        // Obtener el año y mes
        const year = original.getFullYear();
        const month = original.getMonth();

        // Crear una nueva fecha con el día 0 del mes siguiente
        const lastDay = new Date(year, month + 1, 0);

        // Establecer la hora original
        lastDay.setHours(original.getHours());
        lastDay.setMinutes(original.getMinutes());
        lastDay.setSeconds(original.getSeconds());
        lastDay.setMilliseconds(original.getMilliseconds());

        return lastDay;
    }

    const loadReport = () => {

        if (areaId > 0 && dateFrom) {
            setLoading(true);
            const to = getLastDayOfMonth(dateFrom);
            http('reports/sales').asPost({ areaId, productId: null, from: dateFrom, to, tipoFecha: 1, username: '' }).then(resp => {

                const data = resp;

                console.log(data.length);

                const groupedBySale = Object.values(
                    data.reduce((acc, curr) => {
                        const key = `${curr.id}|${curr.date}|${curr.fullName}|${curr.asignedTo}|${curr.total}|${curr.paymentTypeId}|${curr.paymentType}|${curr.payOfDate}|${curr.devolucionesTotal}`;

                        if (!acc[key]) {
                            acc[key] = {
                                asignedTo: curr.asignedTo,
                                total: curr.total,
                                meta: curr.meta,
                                paymentTypeId: curr.paymentTypeId,
                                devolucionesTotal: curr.devolucionesTotal
                            };
                        }

                        return acc;
                    }, {})
                );

                // Paso 2: Agrupar por vendedor y sumar totales
                const totalByAsignedTo = Object.values(
                    groupedBySale.reduce((acc, curr) => {
                        const key = curr.asignedTo;

                        if (!acc[key]) {
                            acc[key] = {
                                asignedTo: key,
                                total: 0,
                                meta: curr.meta,
                                totalContado: 0,
                                totalCredito: 0,
                                devolucionesTotal: 0,
                                granTotal: 0,
                            };
                        }

                        acc[key].total += curr.total;
                        acc[key].devolucionesTotal += curr.devolucionesTotal || 0;
                        acc[key].granTotal += curr.total - (curr.devolucionesTotal || 0);

                        if (curr.paymentTypeId === 1) {
                            acc[key].totalContado += curr.total;
                        } else if (curr.paymentTypeId === 2) {
                            acc[key].totalCredito += curr.total;
                        }

                        return acc;
                    }, {})
                );

                setData(totalByAsignedTo);

                setLoading(false);
            });
        }

    };

    const toMoney = data => formatToMoneyNumber(data.value);

    const title = 'Reporte de Ventas';

    const cellCumplimiento = (e) => {
        const cumplimiento = e.data.total;
        const meta = e.data.meta;

        if (!meta || meta === 0) 
            return <span className="text-muted">Sin meta</span>;
        
        const percentage = (cumplimiento / meta) * 100;
        
        if (isNaN(percentage)) 
            return <span className="text-muted">Sin datos</span>;

        return (
            <div className={Math.abs(percentage) <= 10 ? 'inc cell-text' : 'dec cell-text'}>
                <div className="current-value">
                    {formatToMoney(cumplimiento.toFixed(2))}
                </div>
                <div className="diff">{Math.abs(percentage).toFixed(2)}%</div>
            </div>
        );
    }

    const cellCumplimiento2 = (e) => {
        const cumplimiento = e.data.total;
        const meta = e.data.meta;
        const dateActualSistem = new Date();
        const dayActual = dateActualSistem.getDate();
        const lastDayOfCurrentMonth = new Date(dateActualSistem.getFullYear(), dateActualSistem.getMonth() + 1, 0).getDate();

        if (!meta || meta === 0) 
            return <span className="text-muted">Sin meta</span>;
        
        const percentage = (cumplimiento / meta) * 100;
        
        if (isNaN(percentage)) 
            return <span className="text-muted">Sin datos</span>;

        const percentageRelative = (dayActual / lastDayOfCurrentMonth) * 100;

        const metaSpected = meta * (dayActual / lastDayOfCurrentMonth);

        return (
            <div className={'inc cell-text'}>
                <div className="current-value">
                    {formatToMoney(metaSpected.toFixed(2))}
                </div>
                <div className="diff">{Math.abs(percentageRelative).toFixed(2)}%</div>
            </div>
        );
    }

    return (
        <div className="">

            <Box direction="row" width="100%" height={75}>
                <Item ratio={1}>
                    <div className="ml-10">
                        <label>Mes/año:</label>
                        <DateBox type="date"
                            pickerType='rollers'
                            value={dateFrom}
                            displayFormat={formatDateMMyy}
                            openOnFieldClick={true}
                            onValueChanged={changeDateFrom} />
                    </div>
                </Item>

                <Item ratio={4}>
                    <div style={{ paddingTop: '19px' }}>
                        <Button
                            width={120}
                            text={`${loading ? 'Buscando...' : 'Buscar'}`}
                            type="default"
                            icon="search"
                            stylingMode="contained"
                            className="m-1"
                            disabled={loading}
                            onClick={loadReport}
                        />
                    </div>
                </Item>
            </Box>
            <Box direction="row" width="100%" height={75}>

                <Item ratio={1}>
                    <DataGrid
                        id="gridContainerResumen"
                        ref={refData}
                        keyExpr="asignedTo"
                        selection={{ mode: 'single' }}
                        dataSource={data}
                        showBorders={true}
                        showRowLines={true}
                        hoverStateEnabled={true}
                        onCellPrepared={onCellPreparedSales}
                    >
                        <SearchPanel visible={true} width={200} />
                        <Grouping autoExpandAll={true} />
                        <Paging defaultPageSize={10} />
                        <Pager
                            showInfo={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={[10, 20, 50, 100, 500]}
                        />
                        <Export enabled={true} fileName={title} allowExportSelectedData={true} />

                        <Column dataField="asignedTo" caption="Vendedor" />
                        <Column dataField="totalContado" caption="Contado" cellRender={cellRender()} width={120} />
                        <Column dataField="totalCredito" caption="Crédito" cellRender={cellRender()} width={120} />
                        <Column dataField="total" caption="Monto Total" cellRender={cellRenderBold()} width={120} />
                        <Column dataField="devolucionesTotal" caption="Devoluciones" cellRender={cellRender()} width={120} />
                        <Column dataField="granTotal" caption="Total Ventas" cellRender={cellRenderBold()} width={120} />
                        <Column dataField="meta" caption="Meta" cellRender={cellRender()} width={120} />
                        <Column dataField="cumplimiento" alignment='right' cellRender={cellCumplimiento} width={130} />
                        <Column dataField="cumplimiento2" caption={'Espectativa'} alignment='right' cellRender={cellCumplimiento2} width={130} />
                        <Summary>

                            <TotalItem column="asignedTo" summaryType="sum" customizeText={() => 'Totales :'} />
                            <TotalItem column="totalContado" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="totalCredito" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="total" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="devolucionesTotal" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="granTotal" summaryType="sum" customizeText={toMoney} />

                        </Summary>
                    </DataGrid>
                </Item>
            </Box>
        </div>
    );
}



export default ResumenVentasVendedor;
